import store from '@/store';
import service from '@/services/account';

const useFreshchat = () => {
  let isInitialized = false;
  const showFreshchat = () => {
    function initFreshchat() {
      if (store.state.accountInfo.freshchatExternalId === '') {
        return;
      }

      window.fcWidget.init({
        token: 'da9f8811-8413-4fee-b039-f45eaad735f1',
        host: 'https://hulk.freshchat.com',
        widgetUuid: 'f6944b07-cea7-4c0e-9e3a-83b59f4ecb57',
        externalId: store.state.accountInfo.freshchatExternalId,
        restoreId: store.state.accountInfo.freshchatRestoreId,
        firstName: '',
        lastName: store.state.accountInfo.shopDomain,
      });

      window.fcWidget.user.setProperties({
        name: store.state.accountInfo.shopName,
        email: store.state.accountInfo.shopOwnerEmail,
        plan_name: store.state.accountInfo.planName,
        plan_price: store.state.accountInfo.planPrice,
        review_import_quota_left: store.state.accountInfo.reviewImportQuotaLeft,
        credits_left: store.state.accountInfo.creditsLeft,
        shop_domain: store.state.accountInfo.shopDomain,
        install_orders_count: store.state.accountInfo.shopifyOrdersCount,
        shopify_plan_name: store.state.accountInfo.shopifyPlanName,
        shop_left_appstore_review: store.state.accountInfo.shopLeftAppstoreReview,
        shop_id: store.state.accountInfo.shopId,
      });

      window.fcWidget.on('user:created', function () {
        window.fcWidget.user.get().then(user => {
          const restoreId = user.data.restoreId;
          service.updateFreshchatData({ restoreId });
        });
      });
    }

    function initialize(document, id) {
      let e;
      document.getElementById(id)
        ? initFreshchat()
        : (((e = document.createElement('script')).id = id),
          (e.async = !0),
          (e.src = 'https://hulk.freshchat.com/js/widget.js'),
          (e.onload = initFreshchat),
          document.head.appendChild(e));
    }

    function initiateCall() {
      if (!isInitialized) {
        isInitialized = true;
        initialize(document, 'Freshchat-js-sdk');
      }
    }

    if (document.readyState === 'complete') {
      initiateCall();
    } else {
      window.addEventListener
        ? window.addEventListener('load', initiateCall, !1)
        : window.attachEvent('load', initiateCall, !1);
    }
  };

  return { showFreshchat };
};

export default useFreshchat;
